<template>
  <div v-if="loading" class="loading-overlay">
    <div class="spinner"></div>
    Loading...
  </div>
  <div class="modal show d-block">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="d-flex modal-header justify-space-between align-center">
            <div class="custom-font-title custom-font"><strong>Pallet Label</strong></div>

            <div class="d-flex" style="gap: 10px;">
                <!-- Confirm 버튼 추가 -->
                <v-btn color="success" @click="confirmPalletLabel">Confirm</v-btn>

                <!-- 기존 Close 버튼 유지 -->
                <v-btn icon="$close" variant="text" @click="closeScreen"></v-btn>
            </div>
        </div>

        <v-container>
          <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="-1"
                class="custom-table"
                density="comfortable"
                fixed-header
                height="600px"
            >
            <template #[`item.LotNumber`]="{ item }">
                <vue-datepicker
                    v-model="item.lotNumber"
                    model-type="yyyyMMdd"
                    :enable-time-picker="false"
                    :auto-apply="true"
                    format="yyyy-MM-dd"
                    placeholder="Select Date"
                    class="custom-datepicker"
                    style="max-width: 150px;"
                />
            </template>
                <template #[`item.LackQTY`]="{ item }">
                    <v-text-field
                        v-model="item.lackQty"
                        type="number"
                        variant="outlined"
                        density="compact"
                        hide-details
                        class="text-right"
                        style="max-width: 100px;"
                    />
                </template>

                <template #[`item.LackAmount`]="{ item }">
                    <v-text-field
                        v-model="item.lackAmount"
                        type="number"
                        variant="outlined"
                        density="compact"
                        hide-details
                        class="text-right"
                        style="max-width: 100px;"
                    />
                </template>
                <template #[`item.Copies`]="{ item }">
                  <v-select
                      v-model="item.copies"
                      :items="[2, 4]"
                      dense
                      variant="outlined"
                      hide-details
                      style="max-width: 80px; " 
                  />
              </template>
                <template v-slot:bottom> </template>

            </v-data-table>



        </v-container>
      </div>
    </div>
  </div>
</template>
  
  <script>
import axios from "axios";
import VueDatepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { mapState } from "vuex";

export default {
  props: ["selectedPalletData"],
  components: {
        VueDatepicker
    },
  mounted() {
    // mounted에서 바로 호출
    // 대신 watch 사용
    },
    computed: {
        ...mapState({
        username: (state) => state.username, // Vuex 상태에서 username 가져오기
        userName: (state) => state.userName

        }),
    },

    watch: {
        selectedPalletData: {
            immediate: true,  // 부모에서 열릴 때 바로 실행
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.fetchPalletQty();
                } else {
                    this.items = [];
                }
            }
        }
    },


  data() {

    return {
        
      loading: false,
      headers: [
        { title: "Product No.", value: "productNumber", align: "center"},
        { title: "Product Name", value: "productName", align: "center" },
        { title: "Per Lack Quantity", value: "LackQTY", align: "right" },
        { title: "Lot Number", value: "LotNumber", align: "right" },
        { title: "Lack Amount", value: "LackAmount", align: "right" },
        { title: "Copies", value: "Copies", align: "center" }, // 추가

      ],
      items: [],
    };
  },
  methods: {

    confirmPalletLabel() {

        // 검증 로직
        const invalidItem = this.items.find(item => {
            const isLotNumberInvalid = (
                !item.lotNumber || 
                (typeof item.lotNumber === 'string' && item.lotNumber.trim().length !== 8)
            );

            return (
                item.lackQty === '' || item.lackAmount === '' || 
                Number(item.lackQty) <= 0 || Number(item.lackAmount) <= 0 ||
                isLotNumberInvalid
            );
        });

        if (invalidItem) {
            // 어떤 필드가 문제인지 확인 후 알림
            let message = `The fields for product [${invalidItem.productNumber}] must be greater than 0.`;

            const isLotNumberInvalid = (
                !invalidItem.lotNumber || 
                (typeof invalidItem.lotNumber === 'string' && invalidItem.lotNumber.trim().length !== 8)
            );

            if (isLotNumberInvalid) {
                message = `Please select a valid 8-digit Lot Number (YYYYMMDD) for product [${invalidItem.productNumber}].`;
            }

            alert(message);
            return; // 중단
        }

        // API 호출
        const payload = {
            username: this.username,
            pdfDetails: this.items,
            userName: this.userName
        };


       this.loading = true;
    axios.post(`/api/createPalletLabelPdfForshinwha`, payload, { responseType: 'blob' })
        .then(response => {

            // 새창 열기용 처리
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            window.open(url, "_blank");  // 새창으로 열기

            // 필요시 닫기 (안 닫고 싶으면 주석처리 가능)
            // this.closeScreen();
        })
        .catch(error => {
            console.error("❌ Error generating Pallet Label PDF:", error);
            alert("❌ Failed to generate Pallet Label PDF.");
        })
        .finally(() => {
            this.loading = false;
        });
    },





   async fetchPalletQty() {
    const partNumbers = this.selectedPalletData.map(item => item.partNumber);

    this.loading = true;
    try {
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const dd = String(today.getDate()).padStart(2, '0');
            const todayLotNumber = `${yyyy}${mm}${dd}`;

        const response = await axios.post(`/api/getPalletQtyForshinwha`, {
            partNumbers: partNumbers
        });


        // palletQtyData.data 로 접근해야 정상
        const palletData = response.data.palletQtyData?.data;

        if (response.data.success && Array.isArray(palletData)) {
            // this.selectedPalletData 기준으로 테이블 데이터 구성
            this.items = this.selectedPalletData.map(item => {
                // API에서 partNumber 기준으로 매칭 찾기
                const matched = palletData.find(apiItem => 
                    apiItem.partNumber.trim() === item.partNumber.trim()
                );                
                return {
                    productNumber: item.partNumber,
                    productName: item.partName,
                    lackQty: matched ? matched.palletQty : 0,  // 없으면 0
                    lotNumber: todayLotNumber,  // 기본값 오늘 날짜
                    lackAmount: '',  // 유저가 입력할 값 초기화
                    copies: 2  // 기본 2장으로

                };
            });
        } else {
            console.error("Unexpected response format:", response.data);
            this.items = [];
        }
    } catch (error) {
        console.error("❌ Error fetching pallet qty:", error);
        this.items = [];
    } finally {
        this.loading = false;
    }
},


    closeScreen() {
        this.$emit("close-modal");
        this.item = {};
        },
    }
};
  </script>
  
  <style scoped>
  :deep() .v-table .v-table__wrapper > table > thead > tr > th {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
  }
  
  .data-table-row td {
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6 !important;
    border-bottom: 1px solid #dee2e6 !important;
  }
  
  .data-table-row td {
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6 !important;
    border-bottom: 1px solid #dee2e6 !important;
  }
  
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    z-index: 9999;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
  }
  
  .spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top: 4px solid black;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }
  
 .modal-xl {
  width: 95vw;         /* 화면 너비의 95% 사용 */
  max-width: 1800px;   /* 최대 1800px */
  height: 90vh;        /* 화면 높이의 90% 사용 */
  max-height: 1000px;  /* 최대 높이 */
  margin: auto;        /* 가운데 정렬 */
}
  

  
  .box-qty-input {
    max-width: 150px;
  }
  
  .box-input-control {
    width: 100%;
    text-align: center;
  }
  
  .custom-header-border {
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6 !important;
    border-bottom: 1px solid #dee2e6 !important;
  }
  
  .custom-font-title {
    font-size: xx-large;
    color: black;
  }
  
  .custom-text-color {
    color: black;
    font-weight: 700;
  }

  .custom-table{
    width: 100%;
  }
  .modal-content {
    height: 90vh; /* 모달 내부 높이 조절 */
    max-width: 190vh;
    overflow-y: auto; /* 내용이 많으면 스크롤 가능하게 설정 */
}

  
  /* .dp__main :deep(.dp__clear_icon) {
      position: absolute !important;
      right: 0%;
      top: 16%;
  }
  .dp__main :deep(.dp__input_icon) {
      top: 53% !important;
  } */
  </style>
